import VwHbsHastataniDTO from "src/models/HastaServis/VwHbsHastataniDTO";
import api from "src/services/core/api";

const controllerName = "hastaservis";

export const HastaTaniApi = api.injectEndpoints({
    endpoints: builder => ({
        hastaTaniGetir: builder.query<Array<VwHbsHastataniDTO>, {
            kimlikId: number,
            muracaatId: number,
            hastaServisId: number
        }>({
            query: (request) => ({
                url: controllerName + "/HastaTaniGetir",
                method: "GET",
                params: request
            }),
            providesTags: ["HastaTani"]
        }),
        hastaTaniEkle: builder.mutation<boolean, Array<VwHbsHastataniDTO>>({
            query: (request) => ({
                url: controllerName + "/HbsHastaTaniEkle",
                method: "POST",
                body: JSON.stringify(request)
            }),
            invalidatesTags: ["HastaTani"]
        }),
        hbsHastataniGuncelle: builder.mutation<boolean, VwHbsHastataniDTO>({
            query: (request) => ({
                url: controllerName + "/HbsHastataniGuncelle",
                method: "PUT",
                body: JSON.stringify(request)
            }),
            invalidatesTags: ["HastaTani"]
        }),
        hbsHastataniSil: builder.mutation<boolean, VwHbsHastataniDTO>({
            query: (request) => ({
                url: controllerName + "/hbsHastataniSil",
                method: "DELETE",
                body: JSON.stringify(request)
            }),
            invalidatesTags: ["HastaTani"]
        })
    }),
})

export const {
    useHastaTaniGetirQuery,
    useHastaTaniEkleMutation,
    useHbsHastataniSilMutation,
    useHbsHastataniGuncelleMutation
} = HastaTaniApi;
